var r = 25569, a = 3600 * 1e3, o = 24 * a;
function t(e) {
  return e.getTime() / o + r;
}
export {
  t as default
};
//# sourceMappingURL=index.es344.js.map
